import React from "react";

const InjectStyles = (props) => {
  const styleString = `

:root {
  --primary-color: ${props.color.add_to_cart_button_color};
  --primary-hover-color: #3aa50e;
  --secondary-color: ${props.color.buy_now_button_color};
  --text-color: #1a1a1a;
  --text-color-light: #4d4d4d;
  --border-color: ${props.color.border_color};
 --background-color-light:${props.color.hover_color} ;
  --background-color-lighter: #f9f9f9;
  --background-color-dark: #ececec;
  --error-color: #999;
  --active-border-color:${props.color.active_border_color};;
}

body {
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

.chargezen_variantTitleDisplay {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #333;
}

.chargezen_quantityContainer {
  display: flex;
  align-items: center;
  margin: 15px 0;
}

.chargezen_quantityLabel {
  font-size: 14px;
  font-weight: 500;
  margin-right: 10px;
}

.chargezen_quantitySelector {
  display: flex;
  align-items: center;
}

.chargezen_quantityButton {
  background: none;
  border: 1px solid var(--border-color);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.chargezen_quantityValue {
  margin: 0 10px;
  font-size: 16px;
}

.chargezen_originalPrice {
  text-decoration: line-through;
  color: var(--error-color);
  margin-right: 5px;
}

.chargezen_discountedPrice {
  font-weight: bold;
  color: var(--primary-color);
  margin-right: 5px;
}

.chargezen_discountPercentage {
  font-size: 0.8em;
  color: var(--primary-color);
}

.chargezen_variantOption:not(:last-child) {
  margin-right: 10px;
}

.variant-selector {
  display: flex;
  gap: 0.9rem;
}

.variant-button {
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: 1px solid var(--text-color-light);
  border-radius: 2px;
  box-sizing: border-box;
  color: var(--text-color-light);
  cursor: pointer;
  display: inline-flex;
  flex: 1 1 0%;
  font-family: Silka, HelveticaNeue, "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: 400;
  height: 44px;
  justify-content: center;
  letter-spacing: normal;
  line-height: 17.5px;
  margin: 0;
  padding: 8px 4px;
  text-align: center;
  text-decoration: none;
  text-transform: none;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s,
    box-shadow 0.15s;
  user-select: none;
  vertical-align: middle;
  width: 218.445px;
  -webkit-font-smoothing: antialiased;
}

.variant-button:hover {
  background-color: var(--secondary-color);
  border-radius: 2px;
  color: white;
}

.variant-button[aria-checked="true"] {
  color: var(--secondary-color);
  font-weight: 700;
  background-color: transparent;
  border: 2px solid var(--secondary-color);
}

.variant-button-text {
  font-size: 14px;
}

.variant-button-wrapper.selected {
  background-color: transparent;
}

[data-id="options-button"] {
  display: grid;
  gap: 1rem;
  box-sizing: border-box;
  color: var(--text-color-light);
  column-gap: 16px;
  display: grid;
  font-family: Silka, HelveticaNeue, "Helvetica Neue", sans-serif;
  font-size: 16px;
  height: 199.797px;
  line-height: 24px;
  row-gap: 16px;
  text-size-adjust: 100%;
  unicode-bidi: isolate;
  width: 444.883px;
  -webkit-font-smoothing: antialiased;
  padding-top: 1rem;
}

.group {
  position: relative;
  border-radius: 0.25rem;
  border: 1px solid;
  padding: 0.75rem 1rem;
  transition: border-color 0.15s, background-color 0.15s;
}

.group:hover {
  border-color: var(--primary-color);
  background-color: var(--primary-color);
}

.group.active {
  border-color: var(--primary-color);
  background-color: var(--background-color-light);
  box-shadow: 0 0 0 1px var(--primary-color);
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.gap-x-2\.5 {
  column-gap: 0.625rem;
}

/* Utility classes */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.chargezen_variantSelection {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  margin-bottom: 2%;
  max-width: 100%;
  position: relative;
}

.chargezen_variantOption {
  padding: 5%;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
}

.chargezen_variantOption.selected {
  border-color: var(--primary-color);
  font-weight: 700;
  border: 1.6px solid var(--primary-color);
}
.chargezen_variantOption:hover {
  border-color: var(--primary-color);
  background-color: var(--background-color-light);
  font-weight: 700;
}

.chargezen_variantTitle {
  display: block;
  letter-spacing: 0.125px;
  font-weight: 500;
  margin-bottom: 5px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chargezen_discontinued{
    font-size: 10px;
    font-weight: 400;
}

.chargezen_variantPrice {
  display: block;
  color: var(--text-color-light);
}

.chargezen_selectedVariantName {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  padding: 0px;
  font-weight: 500;
  color: var(--primary-color);
  border-top: 1px solid var(--border-color);
  background-color: var(--background-color-lighter);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 768px) {
  .chargezen_variantSelection {
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 40px; /* Increase padding to accommodate the selected variant name */
  }

  .chargezen_variantOption {
    flex: 0 0 auto;
    width: 150px;
    scroll-snap-align: start;
  }

  .chargezen_selectedVariantName {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }
}

.chargezen_giftsTypesWrapper .chargezen_purchaseCard {
  margin: 12px 0;
}

.chargezen_giftsTypesWrapper .chargezen_purchaseCard .chargezen_purchaseBtn {
  border: 1px solid var(--secondary-color);
  border-radius: 4px;
}
.chargezen_giftsTypesWrapper .chargezen_purchaseCard {
  border: 1.6px solid transparent;
  border-radius: 4px;
}

.chargezen_giftsTypesWrapper .chargezen_purchaseCard:hover {
  border: 1.6px solid var(--primary-color);
  background-color: var(--background-color-light);
}

.chargezen_giftsTypesWrapper .chargezen_purchaseCard.selected {
  border: 1.6px solid var(--primary-color);
  border-radius: 4px;
}

.chargezen_giftsTypesWrapper .chargezen_purchaseCard .chargezen_purchaseBtn {
  border: 1.6px solid var(--secondary-color);
  border-radius: 4px;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard.selected
  .chargezen_purchaseBtn,
.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard:hover
  .chargezen_purchaseBtn {
  border-color: transparent;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard.selected
  .chargezen_purchaseBtn {
  border: none;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnTop {
  padding: 2.5%;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnTop
  p.chargezen_purchaseBtnTitle {
  display: flex;
  margin: 0;
  justify-content: space-between;
  color: var(--text-color);
  font-size: 16px;
  font-weight: 500;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnTop
  p.chargezen_purchaseBtnPrice {
  font-size: 16px;
  line-height: 100%;
  font-weight: 400;
  color: var(--text-color-light);
  margin: 3px 0 0 !important;
}

.chargezen_purchaseBtnBottom {
  border-top: 1px solid #fff;
  padding: 2.5%;
  padding-top: 1px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.chargezen_purchaseBtnBottom.selected {
  background-color: var(--background-color-light);
  border-top: 1px solid var(--primary-color);
}

.chargezen_purchaseBtnBottom ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.chargezen_purchaseBtnBottom
  .chargezen_Block.chargezen_BlockInner
  p.chargezen_blockTitle {
  margin: 0 0 8px;
  font-size: 12px;
  line-height: 1.6;
  text-transform: capitalize;
  color: var(--text-color-light);
  font-weight: 400;
}

.chargezen_purchaseBtnBottom
  .chargezen_Block.chargezen_BlockInner
  .chargezen_dropdownSelected {
  padding: 15px 16px;
  font-weight: 400;
  color: var(--text-color);
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--border-color);
  border-radius: 0.8rem;
}

.chargezen_purchaseBtnBottom
  .chargezen_Block.chargezen_BlockInner
  ul.chargezen_dropdownList {
  position: absolute;
  top: 110%;
  background-color: #fff;
  transition: 0.2s all ease;
  opacity: 1;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  border-radius: 0.8rem 0.8rem 0 0;
  border: 0.1rem solid var(--background-color-dark);
  overflow: hidden;
  transform: translateY(-10px);
  transition: opacity 0.3s, transform 0.3s;
  z-index: 1;
  visibility: visible;
}

.chargezen_dropdown {
  position: relative;
}

.chargezen_purchaseBtnBottom
  .chargezen_Block.chargezen_BlockInner
  ul.chargezen_dropdownList
  > li.chargezen_dropdownListItem {
  padding: 12px 16px;
  font-size: 16px;
  line-height: 2rem;
  font-weight: 400;
  color: var(--text-color);
}

.chargezen_purchaseBtnBottom
  .chargezen_Block.chargezen_BlockInner
  ul.chargezen_dropdownList
  > li.chargezen_dropdownListItem.chargezen_dropdownListItem--selected {
  background-color: var(--background-color-dark);
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnTop
  .chargezen_purchaseBtnTextWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnTop
  .chargezen_purchaseBtnTextWrap
  p.chargezen_purchaseBtnTitle {
  color: var(--text-color);
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnTop
  .chargezen_purchaseBtnTextWrap
  p.chargezen_purchaseBtnSubtitle {
  margin: 0;
  font-size: 12px;
  line-height: 1.6rem;
  font-weight: 400;
  color: var(--text-color-light);
  margin-bottom: 0;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs {
  display: block;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionBlock {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 18px;
  background: var(--background-color-dark);
  border-radius: 0.4rem;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionBlockLeft {
  width: 100%;
  max-width: calc(100% - 90px);
  padding-right: 15px;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionBlockLeft
  p.chargezen_purchaseBtnCollectionBlockTitle {
  margin: 0;
  font-size: 14px;
  line-height: 110%;
  font-weight: 400;
  margin-bottom: 0.4rem;
  color: var(--text-color-light);
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionBlockLeft
  p.chargezen_purchaseBtnCollectionBlockHeading {
  margin: 0 !important;
  font-size: 16px;
  line-height: 120%;
  font-weight: 700;
  margin-bottom: 0.4rem;
  color: var(--text-color);
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionBlockLeft
  p.chargezen_purchaseBtnCollectionBlockCount {
  margin: 0;
  line-height: 1.8rem;
  font-weight: 400;
  font-size: 14px;
  color: var(--text-color-light);
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionBlock
  .chargezen_purchaseBtnCollectionBlockRight {
  width: 100%;
  max-width: 90px;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionBlock
  .chargezen_purchaseBtnCollectionBlockRight
  img {
  width: 100%;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionSubs
  .chargezen_purchaseBtnCollectionSubsTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0 8px;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionSubs
  .chargezen_purchaseBtnCollectionSubsTop
  p.chargezen_purchaseBtnCollectionSubsTitle {
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  color: var(--text-color);
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionSubs
  .chargezen_purchaseBtnCollectionSubsTop
  a.chargezen_purchaseBtnCollectionSubsMore {
  font-weight: 700;
  color: var(--text-color);
  font-size: 16px;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionSubs
  ul.chargezen_purchaseBtnCollectionSubsList
  > li.chargezen_purchaseBtnCollectionSubsListItem {
  display: flex;
  align-items: center;
  font-weight: 400;
  color: var(--text-color-light);
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionSubs
  ul.chargezen_purchaseBtnCollectionSubsList
  > li.chargezen_purchaseBtnCollectionSubsListItem:not(:last-child) {
  margin: 0 8px 8px 0;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnBottom.chargezen_purchaseBtnBottom--coffeeSubs
  .chargezen_purchaseBtnCollectionSubs
  ul.chargezen_purchaseBtnCollectionSubsList
  > li.chargezen_purchaseBtnCollectionSubsListItem
  span
  svg {
  width: 12px;
  height: 9px;
  margin-right: 0.8rem;
}

.chargezen_purchaseBtnBottom
  .chargezen_Block.chargezen_BlockInner
  ul.chargezen_dropdownList {
  margin-top: 10px;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnTop
  .chargezen_purchaseBtnTextWrap
  p.chargezen_purchaseBtnTitle {
  flex-flow: column;
  font-weight: 500;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnTop {
  position: relative;
}

.chargezen_purchaseBtnRadio {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  outline: 1px solid var(--text-color);
  outline-offset: 2px;
  background-color: transparent;
  margin-top: 5px;
  display: inline-block !important;
  position: relative;
}

.chargezen_purchaseBtnRadio.--selected {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  outline: 1px solid var(--primary-color);
}

.chargezen_purchasebtnradio:hover {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  outline: 1px solid var(--primary-color);
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnTop {
  display: flex;
  align-items: flex-start;
}

.chargezen_giftsTypesWrapper
  .chargezen_purchaseCard
  .chargezen_purchaseBtn
  .chargezen_purchaseBtnTop
  > .chargezen_purchaseBtnTextWrap {
  width: 100%;
  max-width: calc(100% - 18px);
  padding-left: 10px;
}

.hidden {
  display: none !important;
}

.chargezen_purchaseCard.selected {
  border: 1.6px solid var(--primary-color);
  border-radius: 4px;
}

button.chargezen_atc {
  background-color: var(--primary-color);
  width: 100%;
  align-items: center;
  appearance: none;
  border: 2px solid rgba(0, 0, 0, 0);
  border-radius: 2px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  /* display: flex; */
  font-family: Silka, HelveticaNeue, "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-weight: 700;
  height: 56px;
  justify-content: space-between;
  letter-spacing: 1.6px;
  line-height: 20.8px;
  margin: 0;
  padding: 8px 24px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  touch-action: manipulation;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s,
    text-decoration-color 0.15s, fill 0.15s, stroke 0.15s, opacity 0.15s,
    box-shadow 0.15s, transform 0.15s, filter 0.15s, backdrop-filter 0.15s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  vertical-align: middle;
  -webkit-font-smoothing: antialiased;
}

button.chargezen_atc:hover {
  background-color: var(--primary-hover-color);
}

button.chargezen_atc_now {
  background-color: var(--secondary-color);
  width: 100%;
  align-items: center;
  appearance: none;
  border: 2px solid rgba(0, 0, 0, 0);
  border-radius: 2px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  /* display: flex; */
  font-family: Silka, HelveticaNeue, "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-weight: 700;
  height: 56px;
  justify-content: space-between;
  letter-spacing: 1.6px;
  line-height: 20.8px;
  margin: 0;
  padding: 8px 24px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  touch-action: manipulation;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s,
    text-decoration-color 0.15s, fill 0.15s, stroke 0.15s, opacity 0.15s,
    box-shadow 0.15s, transform 0.15s, filter 0.15s, backdrop-filter 0.15s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  vertical-align: middle;
  -webkit-font-smoothing: antialiased;
}

p.chargezen_featuresText {
  display: flex;
  gap: 10px;
  align-items: center;
  display: flex;
  justify-content: center;
}

@media (max-width: 767px) {
  .chargezen_purchaseBtnBottom {
    grid-template-columns: repeat(1, 1fr);
  }
}


  `;

  return <style dangerouslySetInnerHTML={{ __html: styleString }} />;
};

export default InjectStyles;